import ApiService from "./api.service";

class CommunicationService extends ApiService {
    searchSms(data) {
        return this.post(`api/meeting/sms/search`, data);
    }
    getSmsStatistics() {
        return this.get(`api/meeting/sms/statistics`);
    }
    getSmsCredits() {
        return this.get(`api/meeting/sms/credits`);
    }
    exportSms(data){
        return this.post(`api/meeting/sms/export`, data, { responseType: "arraybuffer" });
    }
    searchEmails(data) {
        return this.post(`api/meeting/email/search`, data);
    }
    getEmailStatistics() {
        return this.get(`api/meeting/email/statistics`);
    }
    exportEmails(data){
        return this.post(`api/meeting/email/export`, data, { responseType: "arraybuffer" });
    }
    addAnnoucementForUsers(data) {
        return this.post(`api/meeting/announcement`, data)
    }
    getAnnoucementBetweenDates(date_from, date_to) {
        return this.post("api/meeting/announcement/between", { date_from, date_to });
    }
    searchAnnoucements(data) {
        return this.post(`api/meeting/announcement/search`, data)
    }
    deleteAnnouncement(id) {
        return this.delete(`api/meeting/announcement/${id}`)
    }
    updateAnnoucementForUsers(data) {
        return this.post(`api/meeting/announcement/${data.id}`, data)
    }
    showLogs(id) {
        return this.get(`api/meeting/announcement/${id}/logs`)
    }
    getGroups() {
        return this.get('Message/getGroupsForFilter')
    }
    getSpecyficAnnoucement(id) {
        return this.get(`api/meeting/announcement/${id}`)
    }
    reorderAnnoucementAttachemnt(id, data) {
        return this.post(`api/meeting/announcement/${id}/attachements/reorder`, data);
    }
    exportAnnouncementLogs(id) {
        return this.get(`api/meeting/announcement/${id}/export-logs`, { responseType: "arraybuffer" });
    }
}

export default new CommunicationService();